import MealPlan from '@/views/MealPlan/index.vue'

const MealPlanRouter = {
  path: '/meal-plan',
  name: 'MealPlan',
  component: MealPlan,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default MealPlanRouter
